/**
 * Kbd — keyboard key indicator for shortcuts in copy.
 */

export function Kbd({ children }: { children: React.ReactNode }) {
  return (
    <kbd
      style={{
        fontFamily: "var(--font-mono)",
        fontSize: 11,
        padding: "1px 5px",
        background: "var(--surface-2)",
        border: "1px solid var(--hairline)",
        borderRadius: 3,
        color: "var(--ink)",
      }}
    >
      {children}
    </kbd>
  );
}
